export const COUPON_IMPORT_ROLES = ['Administrador', 'Soporte', 'E-commerce']

export const canImportCoupons = role => COUPON_IMPORT_ROLES.includes(role)
